/**
 * MiniMiser.WebApi
 * A web API for client access to patient records.   Build date: 2/19/2019 6:49:21 PM
 *
 * OpenAPI spec version: v1.0.02.19
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface RegisterPatientModel { 
    patientFirstName?: string;
    patientMiddleName?: string;
    patientLastName?: string;
    patientPreferredName?: string;
    patientRelation?: string;
    patientBirthdate?: Date;
    /**
     * False if registering with an existing patient
     */
    newPatient?: boolean;
}
